<template>
  <StoreList v-bind="$props" />
</template>

<script>
import StoreList from '@/components/StoreList';

export default {
  name: 'StoresTab',

  components: {
    StoreList,
  },

  props: [
    /* eslint-disable vue/prop-name-casing, vue/require-prop-types */
    'distributor_id',
    'subdistributor_id',
    'chain_id',
    'store_id',
  ],
};
</script>
